import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/host-grotesk";
import { App } from "./App.jsx";
import "./styles.css";
import "./poster.css";
import "./grid-2026.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
